import React from 'react';

function StatCard({ label, value, valueColor, sub, progress, progressClass, delta, onClick }) {
  return (
    <div
      className={`card-stat${onClick ? ' clickable' : ''}`}
      onClick={onClick}
    >
      <div className="stat-label">{label}</div>
      <div className="stat-value" style={valueColor ? { color: valueColor } : undefined}>
        {value}
      </div>
      {sub && <div className="stat-sub">{sub}</div>}
      {progress !== undefined && (
        <div className="progress-wrap" style={{ marginTop: 10 }}>
          <div
            className={`progress-fill${progressClass ? ` ${progressClass}` : ''}`}
            style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
          />
        </div>
      )}
      {delta && (
        <div className={`stat-delta ${delta.dir === 'up' ? 'delta-up' : 'delta-down'}`}>
          {delta.dir === 'up' ? (
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.8">
              <polyline points="1,7 5,3 9,7" />
            </svg>
          ) : (
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.8">
              <polyline points="1,3 5,7 9,3" />
            </svg>
          )}
          {delta.text}
        </div>
      )}
    </div>
  );
}

export default StatCard;
